<button
    class="w-full h-full flex items-center justify-center border-2 rounded-lg py-2 px-4 transition-colors duration-300 ease-in-out"
    [ngClass]="[
    state ? clickedBackgroundColor : defaultBackgroundColor,
    state ? clickedTextColor : defaultTextColor,
    state ? clickedBorderColor : defaultBorderColor,
    state ? 'font-bold' : ''
    ]" 
    (click)="toggleState()">
    <span class="select-none">{{buttonText}}</span>
</button>